import React, { useEffect, useState, useRef } from 'react';
import styled from 'styled-components';

/* MODAL */
import { useModal } from 'hooks/modalContext';
import CloseBtn from 'components/util/CloseModal';

/* JS */
import * as Server from 'assets/js/Server';

/* DataGrid */
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';

const ProductHistoryModal = props => {
  const { closeModal } = useModal();

  const agGridRef = useRef();

  const [gridRowData, setGridRowData] = useState([]);
  const [defaultColDef] = useState({ editable: false });
  const [colDefs] = useState([{
    headerName: 'Worker Name',
    field: 'workerName',
    flex: 1
  }, {
    headerName: 'Quantity',
    field: 'useQuantity',
    flex: 1
  }, {
    headerName: 'Date',
    field: 'regDate',
    flex: 1
  }]);

  useEffect(() => {
    getProductUsageHistoryList();
  }, []);

  const getProductUsageHistoryList = () => {
    Server.sendGet('product/stock/hist', {
      productSeq: props.props?.data.item?.productSeq,
    }, getProductUsageHistoryListCallback).then();
  };

  const getProductUsageHistoryListCallback = res => {
    res?.['resultList'].forEach(v => {
      v['useQuantity'] = `${v['quantity']}${props.props?.data.item?.productUnit}`
    });

    setGridRowData(res?.['resultList']);
  };

  return (
    <>
      <CloseBtn onClick={closeModal} />

      <Inner>
        <Title>
          <TitHead>
            <i/>
            <h4>Product Usage History</h4>
          </TitHead>
        </Title>
        <ModalForm>
          <FormIn>
            <AgGridReact
              ref={agGridRef}
              className={'dataGrid'}
              rowData={gridRowData}
              columnDefs={colDefs}
              defaultColDef={defaultColDef}
              rowHeight={50}
              headerHeight={40}
            />
          </FormIn>
          <FormBtn $Btn>
            <Btn onClick={closeModal}>Cancel</Btn>
          </FormBtn>
        </ModalForm>
      </Inner>
    </>
  );
}

const Inner = styled.div`
  padding: 40px;
  width: 600px;
  overflow-y: scroll;
  background: #ffffff;
  border-radius: 20px;
  box-sizing: content-box;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.25);

  &::-webkit-scrollbar {
    display: none;
  }
`;

const Title = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const TitHead = styled.div`
  display: flex;
  align-items: center;
  gap: 0 10px;

  & i {
    display: block;
    width: 4px;
    height: 32px;
    border-radius: 0 2px 2px 0;
    background: #1e1e1e;
  }

  & h4 {
    font-weight: 700;
    font-size: 18px;
    color: #000000;
  }
`;

const ModalForm = styled.div`
  margin: 20px 0;
  position: relative;
  border-top: 1px solid #eeeeee;

  & > div + div {
    margin-top: 10px;
  }
`;

const FormIn = styled.div`
  display: flex;
  gap: 10px 20px;

  .dataGrid {
    width: 100%;
    height: 300px !important;

    .ag-header-cell, .ag-header-group-cell {
      border-bottom: 1px solid #eeeeee;
      background: #f8f8f8;
    }

    .ag-header-cell-label {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .ag-ltr .ag-cell {
      border-right-width: 1px;
      padding: 0 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-bottom: 1px solid #eeeeee;
      
      .imgSpanLogo {
        width: 100%;
        height: 100%;
        
        & img {
          width: 100%;
          height: 100%;
        }
      }
    }

    .action-delete {
      padding: 0 15px;
      display: flex;
      align-items: center;
      gap: 0 5px;
      background: #ff4e4e;
      border-radius: 5px;
      margin: auto;
      color: white;
      height: 25px;
    }
  }

  & select {
    width: calc(70% - 10px);
    height: 40px;
    line-height: 40px;
    padding: 0 16px;
    background: #f8f8f8 url('https://ust-india.s3.ap-northeast-2.amazonaws.com/erp-web/sel_arrow.svg') top 50% right 10px no-repeat;
    border: 1px solid #cccccc;
    border-radius: 5px;
    outline: none;
    font-weight: 400;
    font-size: 15px;
    color: #000000;

    &:focus {
      border-color: #0072B9;
    }
  }

  & textarea {
    width: calc(70% - 10px);
    height: 150px;
    padding: 10px 16px;
    background: #f8f8f8;
    border-radius: 5px;
    border: 1px solid #cccccc;
    font-weight: 400;
    font-size: 16px;
    color: #000000;
    resize: none;
    outline: none;

    &:focus {
      border-color: #0072B9;
    }
  }
`;

const FormBtn = styled.div`
  margin-top: 25px !important;
  display: flex;
  align-items: center;
  gap: 0 8px;
`;

const Btn = styled.button`
  flex: 1;
  height: 40px;
  line-height: 40px;
  border-radius: 5px;
  background: ${props => (props['$Color'] ? '#0072b9' : '#a4a4a4')};
  font-weight: 500;
  font-size: 18px;
  color: #ffffff;
  text-align: center;

  &:hover {
    background-color: ${props => (props['$Color'] ? '#075C97' : '#7e7e7e')};
  }
`;

export default ProductHistoryModal;